import { Button, DatePicker, Form, message, Spin } from 'antd';
import moment from 'moment';
import { useCallback, useState, useEffect } from 'react';
import { usePresentmentFilterContext } from '../context/PresenmentFilterProvider';
import { FileExcelFilled } from '@ant-design/icons';
import { PresentmentFilterPaylaod } from 'api/nach';

type Props = {
  setReload?: any;
  // reload?: boolean;
  setFilter?: any;
  filter?: any;
};

function PresentmentFilterForm({ }: Props) {
  const [form] = Form.useForm();
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const { setFilter, filter, prevFilter, setPrevFilter } = usePresentmentFilterContext();
  useEffect(() => {
    // Ensure the filter object exists before trying to access its properties
    if (filter) {
      form.setFieldsValue({
        startDate: filter.startDate ? moment(filter.startDate) : null,
        endDate: filter.endDate ? moment(filter.endDate) : null,
      });
    }
  }, [filter, form]); // This hook will run on mount and whenever the 'filter' object changes

  const filterClicked = () => {
    console.log("reseted data");
    setIsFilterVisible(!isFilterVisible);
  };
  const resetHandler = useCallback(() => {
    form.resetFields();
    console.log("reseted data");
    // if (!filter || !filter.startDate) return;
    // console.log('reset form data ', filter);
    // setFilter({});
    const newFilter: PresentmentFilterPaylaod = {
      startDate: undefined, // Clear dates
      endDate: undefined,
      isExtract: false, // Ensure download flag is false
      pageNo: 1, // Reset pagination
      pageSize: 10,
    };
    setFilter(newFilter);

  }, [form, filter, setFilter]);

  const onSubmit = useCallback(() => {
    message.destroy();
    let startDate = form.getFieldValue('startDate');
    let endDate = form.getFieldValue('endDate');
    console.log(startDate, endDate);
    if (!startDate || !endDate) {
      message.warn('Please select valid date!!');
      return;
    }
    startDate = moment(startDate).format('YYYY-MM-DD 00:00:00');
    endDate = moment(endDate).format('YYYY-MM-DD 23:59:59');
    // const newFilter = { startDate: startDate, endDate };
    // Create new filter, ensure isExtract is false for normal search
    const newFilter: PresentmentFilterPaylaod = {
      startDate: startDate,
      endDate: endDate,
      isExtract: false, // This is a normal search, so no extract
      pageNo: 1, // Reset to first page for a new search
      pageSize: 10, // Reset to default page size for a new search
    };
    setPrevFilter(JSON.stringify(filter));
    setFilter(newFilter);

  }, [form, prevFilter, filter]);


  const handleDownload = useCallback(() => {
    message.destroy();
    if (!filter || !filter.startDate || !filter.endDate) {
      message.warn('Please first search the data using a date range to download.');
      return; // Stop the download process
    }

    let startDate = form.getFieldValue('startDate');
    let endDate = form.getFieldValue('endDate');
    if (!startDate) {
      message.warn('Please select valid start date!!');
      return;
    } else if (!endDate) {
      message.warn('Please select valid end date!!');
      return;
    }

    startDate = moment(startDate).format('YYYY-MM-DD 00:00:00');
    endDate = moment(endDate).format('YYYY-MM-DD 23:59:59');

    let formStartDate = form.getFieldValue('startDate');
    let formEndDate = form.getFieldValue('endDate');

    const formattedFormStartDate = moment(formStartDate).format('YYYY-MM-DD 00:00:00');
    const formattedFormEndDate = moment(formEndDate).format('YYYY-MM-DD 23:59:59');

    // Check if the current filter dates match the form dates
    // If filter.startDate or filter.endDate are undefined, it means no search has been performed yet
    const filterStartDateMatch = filter.startDate === formattedFormStartDate;
    const filterEndDateMatch = filter.endDate === formattedFormEndDate;

    if (!filterStartDateMatch || !filterEndDateMatch || (!filter.startDate && !filter.endDate)) {
      message.warn('Please click on SEARCH first to load data for the selected date range before downloading.');
      return; // Stop the download process
    }

    // Create a new filter object with the download flag set to true
    // Also, reset pageNo and pageSize as we want ALL data for download
    const downloadFilter: PresentmentFilterPaylaod = {
      startDate: startDate,
      endDate: endDate,
      isExtract: true, // This flag signals that a download is requested
      // Do NOT set pageNo or pageSize here if your backend returns all data when isExtract is true
      // or set them to a large number/0 if your backend expects it for "all data"
    };

    setPrevFilter(JSON.stringify(filter)); // Store current filter
    setFilter(downloadFilter); // Update the filter context to trigger download in relevant list component

    // message.loading('Preparing download...'); // Show a loading message
  }, [form, filter, setFilter, setPrevFilter]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          shape="circle"
          icon={
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
              <path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path>
            </svg>
          }
          onClick={filterClicked}
          style={{ float: 'right', zIndex: 1000, border: 0 }}
        />
      </div>
      {isFilterVisible ? (
        <Spin spinning={false}>
          <Form
            form={form}
            onFinish={onSubmit}
            layout="vertical"
            scrollToFirstError
            className="standard-forms"
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-6">
                  <div className="input-box">
                    <Form.Item label="Date of Transaction From: " name="startDate">
                      <DatePicker format={'DD/MM/YYYY'} placeholder="Enter Date of Txn" />
                    </Form.Item>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-6">
                  <div className="input-box">
                    <Form.Item
                      label=" Transaction To:"
                      name="endDate"
                      rules={[
                        {
                          validator(rule, value, callback) {
                            if (value < form.getFieldValue('startDate')) {
                              rule.message = 'To Date should be greater than From Date';
                              callback('To Date should be greater than From Date');
                            } else {
                              callback();
                            }
                          },
                        },
                      ]}
                    >
                      <DatePicker format={'DD/MM/YYYY'} placeholder="Enter Date of Txn" />
                    </Form.Item>
                  </div>
                </div>
                <div style={{ float: 'right', marginBottom: '30px', marginTop: '20px' }}>
                  <Button
                    type="link"
                    icon={<FileExcelFilled />}
                    style={{ float: 'right', fontSize: '30px', color: 'green' }}
                    onClick={handleDownload}
                  ></Button>
                  &nbsp; &nbsp;
                  <Button
                    type="primary"
                    onClick={resetHandler}
                    style={{
                      float: 'right',
                      marginRight: '5px',
                      backgroundColor: 'rgb(44, 152, 151)',
                      border: 'none',
                    }}
                  >
                    {'CLEAR'}
                  </Button>
                  &nbsp; &nbsp;
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      float: 'right',
                      marginRight: '10px',
                      backgroundColor: 'rgb(44, 152, 151)',
                      border: 'none',
                    }}
                  >
                    {'SEARCH'}
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      ) : null}
    </>
  );
}

export default PresentmentFilterForm;
